export default "__VITE_ASSET__17e88608__"